import { FeatureFlags } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { entityRecordUrl } from '@workbuddy/ui/v2/blocks/entity.record';

export function jobRecordRoute(id: string, surfaceEnabled: boolean, stageId?: string): string {

  // Stage deep-links only exist on classic Manage Job — same board as Related Job links, never Jobs Pro.
  if (stageId) return `/jobs/view/${id}/false/job/${stageId}`;
  return surfaceEnabled ? entityRecordUrl('job', 'edit', id)! : `/jobs/view/${id}/true/job`;
}

export function resolveJobRecordRoute(id: string): string {

  return jobRecordRoute(id, ConfigService.environment.featureFlags?.[FeatureFlags.JobManageSurface] === true);
}
